import { el } from 'redom';
import interact from 'interactjs';

import application from 'application';

import './index.scss';

class AssistantResizeHandle {

  constructor(options = { onClick: function noop() {} }) {
    this.assistantContainer = null;
    this.dragged = false;
    this.handleResetExpandedEvent = this.handleResetExpandedEvent.bind(this);
    this.grabHandle = el('.assistant-resize-grab-handle');
    this.el = el('.assistant-resize-handle.visible', {
      onclick: () => {
        if (this.dragged === true) {
          this.dragged = false;
          return;
        }
        const visible = options.onClick();
        if (visible === true) {
          this.el.classList.add('visible');
        } else {
          this.el.classList.remove('visible');
        }
      }
    }, [
      this.grabHandle
    ]);
    this.initDrag();
  }

  setAssistantContainer(container) {
    this.assistantContainer = container;
  }

  initDrag() {
    this.dragStartX = 0;
    this.dragStartWidth = 0;

    interact(this.el).draggable({
      cursorChecker: function() { return null; },
      listeners: {
        start: this.onDragStart.bind(this),
        move: this.onDragMove.bind(this),
        end: this.onDragEnd.bind(this)
      }
    });
  }

  onDragStart(event) {
    this.dragged = true;
    this.dragStartX = event.clientX;
    this.dragStartWidth = this.assistantContainer ? this.assistantContainer.offsetWidth : 0;

    if (this.assistantContainer !== null) {
      this.assistantContainer.style.transition = 'none';
    }
  }

  onDragEnd() {
    if (this.assistantContainer !== null) {
      this.assistantContainer.style.transition = '';
    }
  }

  onDragMove(event) {
    this.dragged = true;
    if (this.assistantContainer === null) {
      return;
    }

    const dx = this.dragStartX - event.clientX;
    const newWidth = this.dragStartWidth + dx;
    const clampedWidth = Math.max(400, Math.min(850, newWidth));

    this.assistantContainer.style.width = clampedWidth + 'px';
  }

  reposition() {
    setTimeout(function someTimeLater() {
      var parentRect = this.el.getBoundingClientRect();
      var grabHandle = this.grabHandle;

      grabHandle.style.left = (parentRect.left - 3) + 'px';
      grabHandle.style.top = (window.innerHeight / 2 - 30) + 'px';
    }.bind(this), 10);
  }

  handleResetExpandedEvent() {

    if (application.assistantManager.assistant.expanded === true) {
      return;
    }

    this.el.click();
  }

  onunmount() {
    application.eventSystem.internal.off('RESET_MIDDLE_PANEL_EXPANDED', this.handleResetExpandedEvent);
  }

  onmount() {
    application.eventSystem.internal.on('RESET_MIDDLE_PANEL_EXPANDED', this.handleResetExpandedEvent);
  }

}

export default AssistantResizeHandle;